import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Table,
    Form,
    Button,
    Modal,
    Card,
} from "react-bootstrap";
import { FaTrash, FaEdit, FaEye, FaPlus, FaComments, FaTasks } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";

const CommentList = () => {
    const [commentList, setCommentList] = useState([]);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { task_id } = useParams();
    const [message, setMessage] = useState([]);
    const [commentId, setCommentId] = useState([]);
    const [show, setShow] = useState(false);
    const userId = (localStorage.getItem("user_id") || "").replace(/"/g, "");

    const handleShow = () => {
        setMessage("");
        setCommentId(null);
        setShow(true);
    };

    const handleClose = () => {
        setMessage("");
        setCommentId(null);
        setShow(false);
    };

    const handleEdit = (comment) => {
        setMessage(comment.description);
        setCommentId(comment.comment_id);
        setShow(true);
    };

    const handleSave = () => {
        if (!message.trim()) return;

        if (commentId) {
            console.log("Comment id is ", commentId);
            axios.post(`${API_BASE_URL}comment_edit.php`,
                {
                    comment_id: commentId,
                    message: message
                }
            )
                .then((response) => {
                    if (response.data.head.code === 200) {
                        window.location.reload();
                    } else {
                        console.error("Error Fetching Data:", response.data.head.msg);
                    }
                })
                .catch((error) => {
                    console.error("API Error:", error);
                }).finally(() => {
                });
        } else {
            console.log("message ", message);

            axios.post(`${API_BASE_URL}comment_add.php`, { message: message, task_id: task_id, user_id: userId })
                .then((response) => {
                    if (response.data.head.code === 200) {
                        window.location.reload();
                    } else {
                        console.error("Error Fetching Data:", response.data.head.msg);
                    }
                })
                .catch((error) => {
                    console.error("API Error:", error);
                }).finally(() => {
                });
        }

        handleClose();
    };

    useEffect(() => {
        axios.post(`${API_BASE_URL}comment_list.php`, { task_id: task_id })
            .then((response) => {
                if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
                    setCommentList(response.data.body);

                } else {
                    console.error("Error Fetching Data:", response.data.head.msg);
                    setCommentList([]);
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
                setCommentList([]);
            }).finally(() => {
            });
    }, []);

    // Pagination over filtered results
    const {
        currentPage,
        totalPages,
        currentItems,
        handlePageChange,
        indexOfFirstItem,
    } = usePagination(commentList, 25); // 4 tasks per page



    return (
        <>
            {/*
            <Container fluid className="my-4 outer-container">
                <div className="d-flex justify-content-between mb-2">
                    <p></p>
                    <h2 className="text-center">Comment List</h2>
                    <div className="d-flex gap-2">
                        <Button
                            onClick={handleShow}
                            className="btn btn-top"
                        >
                            Add Message
                        </Button>

                        <Button
                            className="btn-top"
                            onClick={() => window.history.back()}
                        >
                            Back
                        </Button>
                    </div>
                </div>
                {currentItems.length === 0 && (
                    <Container fluid className="outer-container my-4">
                        <Row>
                            <Col>
                                <div className="not-found-box">Loading...</div>
                            </Col>
                        </Row>
                    </Container>
                )}

                <div className="table-pagination-wrapper">
                    <div className="table-pagination-content">
                        <Table bordered responsive className="table-striped my-3 customer-table">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Message</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((comment, i) => (
                                    <tr key={comment.comment_id}>
                                        <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                                        <td>{comment.added_date}</td>
                                        <td>{comment.user_name}</td>
                                        <td>{comment.description}</td>
                                        <td>
                                            <div className="">
                                                    
                                                        <FaEdit
                                                            className="edit-icon me-3"
                                                            onClick={() => handleEdit(comment)}
                                                            title="Edit"
                                                        />
                                                        
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>

                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </Container>
            */}
            <Container fluid className="my-4 outer-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="task-title">Comment List</h2>

                    <div className="d-flex gap-2">
                        <Button onClick={handleShow} className="btn btn-top">
                            Add Message
                        </Button>

                        <Button className="btn-top" onClick={() => window.history.back()}>
                            Back
                        </Button>
                    </div>
                </div>
                {currentItems.length === 0 ? (
                    <div className="not-found-box">Loading...</div>
                ) : (
                    <div className="comment-list">
                        {currentItems.map((comment, i) => (
                            <div className="comment-card" key={comment.comment_id}>
                                {/* Date & User Row */}
                                <div className="comment-meta">
                                    <div className="comment-date">
                                        <i className="bi bi-calendar-event"></i>
                                        <span>{comment.added_date}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        {/* User */}
                                        <div className="comment-user d-flex align-items-center gap-2">
                                            <i className="bi bi-person"></i>
                                            <span>{comment.user_name}</span>
                                        </div>
                                        <div style={{ width: "10px" }}></div>
                                        {/* Actions */}
                                        {comment.user_id === userId && (
                                        <div
                                            className="comment-actions d-flex align-items-center gap-2"
                                            onClick={() => handleEdit(comment)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <FaEdit className="edit-icon" title="Edit" />
                                            <span>Edit</span>
                                        </div>
                                        )}
                                    </div>

                                </div>

                                {/* Message */}
                                <p className="comment-message">
                                    {comment.description}
                                </p>



                                {/* Divider */}
                                <hr className="comment-divider" />
                            </div>
                        ))}
                    </div>
                )}
                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </Container>


            <Modal show={show} onHide={handleClose} centered className="department-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{commentId ? "Edit Message" : "Add Message"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Message</Form.Label>
                            <Form.Control
                                // type="text"
                                  as="textarea"
                                value={message}
                                   rows={5}  
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Enter Message"
                            />
                        </Form.Group>
                        <Button className="btn-submit btn" onClick={handleSave}>
                            {commentId ? "Update" : "Submit"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CommentList;
